<template>
    <div style="background:#f0f9fd;">
        <div class="lefttop"><span></span>云验证</div>    
        <dl class="leftmenu">
            <dd v-for="parent,index in parentList">
                <div class="title" @click="activeM(parent,index)"><span><img :src="parent.img" /></span>{{parent.name}}</div>
                <ul class="menuson" v-show="parent.isOpen">
                    <li v-for="child,cindex in parent.childList" :class="{active:child.isActive}" @click="activeFun(child)">
                        <cite></cite><a :href="child.url" target="rightFrame">
                            {{child.name}}
                        </a>
                    </li>
                </ul>
            </dd>
        </dl>
    </div>
</template>
<script>
import txlIco from '@/assets/images/leftico01.png';
export default {
    data(){
        return{
            parentList:[{
                name:'服务介绍',
                img: txlIco,
                isOpen:true,
                childList:[
                    {name:'联系方式',url:'/contact', isActive: true},
                    {name:'云验证介绍',url:'/introduce2office', isActive: false},
                    {name:'使用指南',url:'/useguideindex', isActive: false},
                ]
            }]
        }
    },
    methods:{
        activeFun: function(data){
            this.parentList.forEach(function(obj){
                 obj.childList.forEach(function(cobj){
                    cobj.isActive = false;   
                });
            });
            
            data.isActive = !data.isActive;
        },
        activeM: function(data,selecIndex){
            this.parentList.forEach(function(obj,index){
                if(index != selecIndex)
                    obj.isOpen = false;
            });
            data.isOpen = !data.isOpen;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shouye/kefuindexleft.vue